module.exports = __webpack_public_path__ + "img/back-page.a1839381.svg";